import CardShell from './CardShell';

export type { FooterLink, FooterSocialButton, SocialIconName } from './CardShell';
export { AUTH_CARD_MAX_WIDTH_PX } from './CardShell';

export default CardShell;
